// Keep taskInfo intact for diagnosis; only translate known restore errors for display.
export function formatRestoreFailure(taskType: string, taskInfo: string): string {
  if (taskType !== 'WEB_BACKUP_RESTORE' || typeof taskInfo !== 'string') {
    return taskInfo
  }
  if (!taskInfo.includes('存在文件保护属性') || !taskInfo.includes('已拒绝恢复')) {
    return taskInfo
  }

  const protectedPath = taskInfo.match(/路径\s*"([^"]+)"\s*存在文件保护属性/)?.[1]
  const normalized = protectedPath?.replace(/\\+/g, '/')
  // Show a path relative to the website, never the server's physical directory.
  const relativePath = normalized?.match(
    /^(?:\/webHome\/[^/]+|[a-z]:\/VirtualHost\/LocalUser\/[^/]+)\/www(\/.*)?$/i
  )
  const sitePath = relativePath ? relativePath[1] || '/' : ''
  const file = sitePath && sitePath.length <= 160 ? `文件或目录“${sitePath}”` : '部分文件或目录'
  return `恢复失败：${file}已开启防篡改保护，请在“文件防篡改”中解除对应保护后重试。`
}
